const role = {
  Admin: 1,
  Patient: 2,
  Client: 3,
  ClientUser: 4,
  ClientOrderer: 5,
  ClientProvider: 6,
  ClientAdmin: 7
}

export default role;